import axios from "axios";
// user register
import { api } from "../../api";
export const userRegister = (data) => async (dispatch) => {
  dispatch({ type: "AUTHENTICATION_SET_LOADER" });
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await axios.post(
      `${api}/api/v2/user-register`,

      data,
      config
    );

    localStorage.setItem("authToken", response.data.token);
    dispatch({
      type: "REGISTER_SUCCESS",
      payload: {
        successMessage: response.data.successMessage,
        token: response.data.token,
      },
    });
  } catch (error) {
    console.log(error.response);
    dispatch({
      type: "REGISTER_FAIL",
      payload: {
        error: error.response.data.error.errorMessage,
      },
    });
  }
};

// user login
export const userLogin = (data) => {
  return async (dispatch) => {
    dispatch({ type: "AUTHENTICATION_SET_LOADER" });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        `${api}/api/v2/user-login`,

        data,
        config
      );

      localStorage.setItem("authToken", response.data.token);
      dispatch({
        type: "USER_LOGIN_SUCCESS",
        payload: {
          successMessage: response.data.successMessage,
          token: response.data.token,
        },
      });
    } catch (error) {

      dispatch({
        type: "USER_LOGIN_FAIL",
        payload:error.response.data.error.errorMessage
      });
    }
  };
};

// logout
export const userLogout = () => async (dispatch) => {
  try {
    const response = await axios.post(
      `${api}/api/v2/user-logout`
    );
    if (response.data.success) {
      localStorage.removeItem("authToken");
      dispatch({
        type: "LOGOUT_SUCCESS",
      });
    }
  } catch (error) {

  }
};

// get all users  by pagination

export const getALlUsersByPagination = (page) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-users-by-pagination?page=${page}`
    );

    dispatch({
      type: "PERPAGE_USER_GET_SUCCESS",
      payload: {
        allUser: response.data.allUser,
        parPage: response.data.parPage,
        userCount: response.data.userCount,
      },
    });
  } catch (error) {
    console.log(error.response);
  }
};

// delete user

export const deleteUser = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${api}/api/v2/delete-user/${id}`
    );
  
    dispatch({
      type: "USER_DELETE_SUCCESS",
      payload: response.data.success,
    });
  } catch (error) {
    console.log(error.response);
  }
};

// get my inFo

export const getMyInfo = (id) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-myinfo/${id}`
    );
   
    dispatch({
      type: "USER_INFO_GET_SUCCESS",
      payload: response.data.myInfo,
    });
    dispatch({
      type: "EDIT_REQUEST_SET",
    });
  } catch (error) {
    console.log(error.response);
  }
};

// update
export const updateProfile = (id, data) => async (dispatch) => {
  dispatch({ type: "AUTHENTICATION_SET_LOADER" });

  try {
    const response = await axios.patch(
      `${api}/api/v2/update-myinfo/${id}`,
      data
    );

    dispatch({
      type: "USER_INFO_UPDATE_SUCCESS",
      payload: response.data.successMessage,
    });
  } catch (error) {
    console.log(error.response);
  }
};

// get user messages

export const getMyMessages = (email) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-user-messages/${email}`
    );

    dispatch({
      type: "USER_MESSAGE_GET_SUCCESS",
      payload: response.data.myMessages,
    });
  } catch (error) {
    console.log(error.response);
  }
};


// delete message 
export const deleteUserMessage = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${api}/api/v2/delete-user-message/${id}`
    );

    dispatch({
      type: "USER_MESSAGE_DELETE_SUCCESS",
      payload: response.data.success,
    });
  } catch (error) {
    console.log(error.response);
  }
};


// get user order 

export const getMyOrder = (email) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${api}/api/v2/get-user-order/${email}`
    );

    dispatch({
      type: "USER_ORDER_GET_SUCCESS",
      payload: response.data.myOrder,
    });
  } catch (error) {
    console.log(error.response);
  }
};

// delete order 
export const deleteUserOrder = (id) => async (dispatch) => {
  try {
    const response = await axios.delete(
      `${api}/api/v2/delete-user-order/${id}`
    );
   
    dispatch({
      type: "USER_ORDER_DELETE_SUCCESS",
      payload: response.data.success,
    });
  } catch (error) {
    console.log(error.response);
  }
};



